// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__zpHK6","log":"ModalInventoryLogs_log__1OP7J","date":"ModalInventoryLogs_date__3-GIZ","userName":"ModalInventoryLogs_userName__21VSc"};